export default {
  // 空
  'comp-empty': () => import('./empty'),
  'comp-empty-config': () => import('./empty/config'),
  'comp-empty-option': () => import('./empty/option'),
  // 楼层导航
  'comp-floor-menu': () => import('./floor-menu'),
  'comp-floor-menu-config': () => import('./floor-menu/config'),
  'comp-floor-menu-option': () => import('./floor-menu/option'),
  // 底部导航
  'comp-bottom-menu': () => import('./bottom-menu'),
  'comp-bottom-menu-config': () => import('./bottom-menu/config'),
  'comp-bottom-menu-option': () => import('./bottom-menu/option'),
  // 表单
  'comp-form': () => import('./form'),
  'comp-form-config': () => import('./form/config'),
  'comp-form-option': () => import('./form/option'),
  // 金刚位
  'comp-grid-menu': () => import('./grid-menu'),
  'comp-grid-menu-config': () => import('./grid-menu/config'),
  'comp-grid-menu-option': () => import('./grid-menu/option'),
  // 图片
  'comp-image': () => import('./image'),
  'comp-image-config': () => import('./image/config'),
  'comp-image-option': () => import('./image/option'),
  // 优惠券贴图
  'comp-coupon-image': () => import('./coupon-image'),
  'comp-coupon-image-config': () => import('./coupon-image/config'),
  'comp-coupon-image-option': () => import('./coupon-image/option'),
  // 文本
  'comp-text': () => import('./text'),
  'comp-text-config': () => import('./text/config'),
  'comp-text-option': () => import('./text/option'),
  // 倒计时
  'comp-timeout': () => import('./timeout'),
  'comp-timeout-config': () => import('./timeout/config'),
  'comp-timeout-option': () => import('./timeout/option'),
  // 横向列表
  'comp-horizontal-list': () => import('./horizontal-list'),
  'comp-horizontal-list-config': () => import('./horizontal-list/config'),
  'comp-horizontal-list-option': () => import('./horizontal-list/option'),
  // 纵向列表
  'comp-vertical-list': () => import('./vertical-list'),
  'comp-vertical-list-config': () => import('./vertical-list/config'),
  'comp-vertical-list-option': () => import('./vertical-list/option'),
  // 横向滚动
  'comp-scroll-left': () => import('./scroll-left'),
  'comp-scroll-left-config': () => import('./scroll-left/config'),
  'comp-scroll-left-option': () => import('./scroll-left/option'),
  // 轮播图
  'comp-swiper-banner': () => import('./swiper-banner'),
  'comp-swiper-banner-config': () => import('./swiper-banner/config'),
  'comp-swiper-banner-option': () => import('./swiper-banner/option'),
  // 轮播图 卡片式
  'comp-swiper-card': () => import('./swiper-card'),
  'comp-swiper-card-config': () => import('./swiper-card/config'),
  'comp-swiper-card-option': () => import('./swiper-card/option'),
  // 页面FAQ
  'comp-page-faq': () => import('./page-faq'),
  'comp-page-faq-config': () => import('./page-faq/config'),
  'comp-page-faq-option': () => import('./page-faq/option'),
  // 页面引言
  'comp-page-intro': () => import('./page-intro'),
  'comp-page-intro-config': () => import('./page-intro/config'),
  'comp-page-intro-option': () => import('./page-intro/option'),
  // 段落模块
  'comp-page-paragraph': () => import('./page-paragraph'),
  'comp-page-paragraph-config': () => import('./page-paragraph/config'),
  'comp-page-paragraph-option': () => import('./page-paragraph/option'),
  // 页面标题
  'comp-page-title': () => import('./page-title'),
  'comp-page-title-config': () => import('./page-title/config'),
  'comp-page-title-option': () => import('./page-title/option'),
  // 滚动新闻
  'comp-news-marquee': () => import('./news-marquee'),
  'comp-news-marquee-config': () => import('./news-marquee/config'),
  'comp-news-marquee-option': () => import('./news-marquee/option'),
  // 网格标题
  'comp-grid-header': () => import('./grid-header'),
  'comp-grid-header-config': () => import('./grid-header/config'),
  'comp-grid-header-option': () => import('./grid-header/option'),
  // 网格单元
  'comp-grid-list': () => import('./grid-list'),
  'comp-grid-list-config': () => import('./grid-list/config'),
  'comp-grid-list-option': () => import('./grid-list/option'),

}
